
export const DownloadDOC = (blob: any, name:string) => {
  const anchorElement = document.createElement('a')
  const objectUrl = window.URL.createObjectURL(blob)
  anchorElement.href = objectUrl
  anchorElement.download = name

  document.body.appendChild(anchorElement)
  anchorElement.click()  
  cleanElement(objectUrl, anchorElement)
}

function cleanElement(objectUrl:any, anchorElement:any) {
  window.URL.revokeObjectURL(objectUrl)
  anchorElement.removeEventListener('load', cleanElement)
  document.body.removeChild(anchorElement)
}